import {
  Dataviz,
  DatavizName,
  getDefaultDataviz,
} from "@radarly/models/dataviz";
import { EmptyFragment } from "@radarly/models/search";
import { isTextCardDataviz } from "../dataviz";
import { Card, TextCard } from "../model";
import { CardFactory, CardFragmentsFactory } from "./base";
import { ICardFactory } from "./model";

export class TextCardFragmentsFactory extends CardFragmentsFactory {
  static create() {
    const factory = new TextCardFragmentsFactory();
    return factory.getFragment();
  }
  private getFragment(): EmptyFragment {
    return [];
  }
}

export class TextCardFactory
  implements ICardFactory<TextCard, Record<string, unknown>>
{
  public static getInstance() {
    return new TextCardFactory();
  }
  public fromCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    input?: { dataviz?: Dataviz }
  ) {
    return CardFactory.getInstance<TextCard>().createCard(
      workspaceId,
      projectFocuses,
      "text",
      card.title,
      TextCardFragmentsFactory.create(),
      this.createDataviz(input?.dataviz || card.dataviz)
    );
  }
  public fromInput(
    workspaceId: number,
    projectFocuses: number[],
    title: string,
    input?: { dataviz?: Dataviz["name"]; fullDataviz?: Dataviz }
  ) {
    return CardFactory.getInstance<TextCard>().createCard(
      workspaceId,
      projectFocuses,
      "text",
      title,
      TextCardFragmentsFactory.create(),
      this.createDataviz(
        input?.fullDataviz ??
          getDefaultDataviz(input?.dataviz || DatavizName.Text)
      )
    );
  }
  public createDataviz(dataviz: Dataviz) {
    if (isTextCardDataviz(dataviz)) {
      return dataviz;
    } else {
      return getDefaultDataviz(DatavizName.Text) as TextCard["dataviz"];
    }
  }
}
